import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SpgFormPageRoutingModule } from './spg-form-routing.module';

import { SpgFormPage } from './spg-form.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SpgFormPageRoutingModule,
    ReactiveFormsModule,
    IonicSelectableModule
  ],
  declarations: [SpgFormPage]
})
export class SpgFormPageModule {}
